import globalState from '../state';
import CONSTANTS from '../constants';

let initialStateSol = globalState.solicitacao;

let cursoInteresse = (state = initialStateSol.cursoInteresse, action) => {
    var payload = action.payload;

    var acoes = {
        [CONSTANTS.CARREGAR_FINANCIAMENTOS_DISPONIVEIS.LOADING]: () => {
            return { ...state, carregando: true };
        },

        [CONSTANTS.CARREGAR_FINANCIAMENTOS_DISPONIVEIS.SUCCESS]: () => {
            return { ...state, ...action.payload, carregando: false };
        },

        [CONSTANTS.CARREGAR_FINANCIAMENTOS_DISPONIVEIS.ERROR]: () => {
            return { ...state, erro: action.payload.message || "ERROR", carregando: false };
        },

        [CONSTANTS.CHANGE_CURSO]: () => {
            return {
                ...state,
                curCodigo: payload.curCodigo,
                listPeriodo: payload.listPeriodo,
                curURL: payload.curURL,
                perPeriodo: 0,
                polCodigo: 0,
                solPercentual: 0,
                maximoPercent: 0,
                perDtFim: payload.perDtFim,
                perSeq: payload.perSeq
            };
        },

        [CONSTANTS.CHANGE_PERIODO]: () => {
            return { ...state, perDtFim: payload.perDtFim,  perPeriodo: payload.perPeriodo, listPolo: payload.listPolo, polCodigo: 0, solPercentual: 0, maximoPercent: 0, perSeq: payload.perSeq };
        },

        [CONSTANTS.CHANGE_POLO]: () => {
            return { ...state, perDtFim: payload.perDtFim, polCodigo: payload.polCodigo, maximoPercent: payload.maximoPercent, perSeq: payload.perSeq };
        },

        [CONSTANTS.CHANGE_PERCENTDESEJADO]: () => {
            console.log(Number(payload.solPercentual))
            return { ...state, solPercentual: Number(payload.solPercentual) };
        },

        [CONSTANTS.CHANGE_MOTIVO]: () => {
            return { ...state, solMotivo: payload }
        }

    };
    if (acoes[action.type]) {
        return acoes[action.type]();
    }
    return state;

};




export default cursoInteresse;


// WEBPACK FOOTER //
// ./src/reducers/curso-interesse.js